import type { Option } from '@zen/DesignSystem/types';
import type { Optional } from '@zen/utils/typescript';

import type { DocumentPermissions, DocumentType } from './types';

export const getDefaultDocumentPermissions = (): DocumentPermissions => {
  return {
    agentForwarder: true,
    customerUser: true,
    manufacturer: true
  };
};

export const getDocumentTypeOptions = (docTypes: DocumentType[]): Option<string>[] => {
  if (!docTypes) {
    return [];
  }

  return docTypes.map((docType) => ({
    label: docType.title || '',
    value: docType.name || ''
  }));
};

export const getFileExtension = (fileUrl: Optional<string>): string => {
  if (!fileUrl) return '';

  const cleanUrl = fileUrl.split('?')[0];
  const fileName = cleanUrl.split('/').pop() || '';
  const ext = fileName.split('.').pop() || '';

  return ext === fileName ? '' : ext.toLowerCase();
};
